import React from "react";
import TopBar from "./TopBar";
import BottomNav from "./BottomNav";
import { useProfile } from "../context/ProfileContext";
import { THEMES } from "../data/gameData";

export default function AppShell({ children, hideNav }) {
  const { profile } = useProfile();
  const themeId = profile?.equipped?.theme;
  const theme = themeId && THEMES[themeId];
  const useCustom = theme && themeId !== "theme_aurora";

  return (
    <div className={`mr-noise relative ${useCustom ? "" : "mr-bg"}`}
         style={useCustom ? { background: theme.bg, minHeight: "100vh" } : {}}>
      <TopBar />
      <main className="relative z-10 max-w-4xl mx-auto px-4 pt-4 pb-28">{children}</main>
      {!hideNav && <BottomNav />}
    </div>
  );
}
